// extracted by mini-css-extract-plugin
module.exports = {"gvItem":"GVItem_gvItem__SfGDN","value":"GVItem_value__l3NPb","rightButtons":"GVItem_rightButtons__OU2OF"};